/* "Exportar CSV" (owner 2026-10-19): the button and, under it, the last refusal. */
.export {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-1);
}

.failure {
  margin: 0;
  max-inline-size: 40ch;
  color: var(--danger-text);
  font-size: var(--font-size-12);
}
